import { Injectable, Injector } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs/Observable';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { ProcessDeUtil } from './process-de-util';
import { AuditProcessDefInfo } from './entities/audit-processDef-info';
import { ProcessInfo } from '../model/process-info';
import { RTProcessInfo } from '../model/rt-process-info';

@Injectable()
export class ProcessDesignerDataService {
    constructor(
        private http: HttpService,
        private util: ProcessDeUtil) { }

    // 基于流程分类ID获取流程分类信息
    GetFlowFormbyId(id: string): Observable<any> {
        if (id) {
            let url = this.util.getFlowFormWebApi() + '/getFlowForm';
            url += `/${id}`;
            return this.http.get(url);
        }
    }
    // 基于流程分类获取参数列表
    getParametersbyFlowFormKey(id: string): Observable<any> {
        if (id) {
            let url = this.util.getFormalParametersWebApi();
            url += `?flowFormKey=${id}`;
            return this.http.get(url);
        }
    }
    // 基于流程分类获取流程构件
    getComponentsbyFlowformkey(id: string): Observable<any> {
        if (id) {
            let url = this.util.getBizComponentsWebApi();
            url += `/query?param=` + encodeURIComponent(`{"flowFormKey":"${id}"}`);
            return this.http.get(url);
        }
    }
    // 基于流程分类获取表单定义
    getExecuteFormbyFlowFormKey(id: string): Observable<any> {
        if (id) {
            let url = this.util.getExcuteFormsWebApi();
            url += `?flowFormKey=${id}`;
            return this.http.get(url);
        }
    }
    /**
     * 基于流程分类Id获取业务活动
     * @param ffId 流程分类id
     */
    getBizActivities(ffId: string) {
        if (ffId) {
            const url = this.util.getBizActivityWebApi(ffId);
            return this.http.get(url);
            // .pipe(
            //     map((re: any) => re),
            //     mergeMap((activities: any[]) => {
            //         if (activities && activities.length > 0) {
            //             return forkJoin(activities.map(activity => {
            //                 return forkJoin(this.getBizActivityComponents(ffId, activity.id),
            //                     this.getBizActivityActions(activity.id))
            //                     .pipe(
            //                         map((re: any[]) => {
            //                             activity.components = re[0];
            //                             activity.actions = re[1];
            //                             return activity;
            //                         }));
            //             }));
            //         } else {
            //             return of([]);
            //         }
            //     })
            // );
        }
    }

    /**
     * 基于流程分类ID获取自定义动作
     * @param formId 流程分类ID
     */
    getCustomizeActions(formId: string): Observable<any> {
        if (formId) {
            const url = `/api/runtime/wf/v1.0/customizeAction?flowFormKey=${formId}`;
            return this.http.get(url);
        }
    }
    /**
     * 基于业务活动id获取业务活动构件
     * @param id 业务活动id
     */
    private getBizActivityComponents(flowFormId: string, id: string) {
        if (id) {
            let url = this.util.getBizComponentsWebApi();
            url += `/query?param=` + encodeURIComponent(`{"flowFormKey":"${flowFormId}","owner":"${id}","ownerType":"Activity"}`);
            return this.http.get(url);
        }
    }
    private getBizActivityActions(id: string) {
        if (id) {
            let url = this.util.getApprovalActionWebApi();
            url += `?bizActivityId=${id}`;

            return this.http.get(url);
        }
    }
    // 基于ID获取BE
    getBusinessEntitybyId(id: string): Observable<any> {
        if (id) {
            // let url = this.util.getMetaDataRUWebApi();
            // url += id;
            // const url = `/api/runtime/lcm/v1.0/bef/handledBeMeta?beId=${id}`;
            const url = `/api/runtime/lcm/v1.0/bef/expression?beId=${id}`;
            return this.http.get(url);
        }
    }
    /**
     * 基于流程定义Key获取上下文
     * @param key 流程定义key
     */
    getProcContentbyKey(key: string): Observable<any> {
        if (key) {
            let url = this.util.getProcessDefinitionWebApi();
            url += `/bpmnModel?procDefKey=${key}`;
            return this.http.get(url);
        }
    }
    /**
     * 基于流程定义Key获取上下文
     * @param key 流程定义Id
     */
    getRTProcContentbyId(id: string): Observable<any> {
        if (id) {
            let url = this.util.getRTProcessDefinitionWebApi();
            url += `/${id}/bpmnModel`;
            return this.http.get(url);
        }
    }
    /**
     * 查询当前设计时流程是否处在审核状态中
     * @param procDefKey 流程定义key 
     * @returns 
     */
    findReleaseProcessByProcDefKey(procDefKey: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/dtProcDefs/checkRelease?procDefKey=${procDefKey}`;
        return this.http.get(url);
    }
    /**
     * 保存流程
     * @param content
     */
    saveProcess(content: string, processInfo: ProcessInfo, state: number): Observable<any> {
        if (content) {
            const postData = {
                organization: processInfo.procOrg ? processInfo.procOrg.orgId : '',
                organizationName: processInfo.procOrg ? processInfo.procOrg.orgName : '',
                accessLevel: processInfo.accessLevel,
                procContent: content,
                state
            };
            const url = this.util.getProcessDefinitionWebApi();
            return this.http.post(url, JSON.stringify(postData));
        }
    }
    saveAsProcess(content: string, bizDefKey: string, procKey: string, procName: string, procId: string): Observable<any> {
        if (content) {
            const postData = {
                newBizDefKey: bizDefKey,
                newProcKey: procKey,
                newProcName: procName,
                newProcId: procId,
                oldprocContent: content,
            };
            const url = this.util.getProcessDefinitionWebApi() + '/copyBpmnModel';
            return this.http.post(url, JSON.stringify(postData));
        }
    }

    auditProcessDef(info: AuditProcessDefInfo) {
        const url = '/api/runtime/wf/v1.0/dtProcDefs/auditProcessDef';
        this.http.post(url, info).subscribe(re => { });
    }

    /**
     * 发布流程
     * @param content
     */
    deployProcess(content: string): Observable<any> {
        if (content) {
            const postData = {
                procDefContent: content
            };
            const url = this.util.deployWebApi();
            return this.http.post(url, JSON.stringify(postData));
        }
    }

    saveRTProcess(content: string, procDefId: string): Observable<any> {
        if (content) {
            const postData = {
                procDefContent: content
            };
            let url = this.util.getRTProcessDefinitionWebApi();
            url += `/${procDefId}/adjust`;
            return this.http.post(url, JSON.stringify(postData));
        }
    }

    syncDtProcess(content: string, rtProcessInfo: RTProcessInfo): Observable<any> {
        if (content) {
            const postData = {
                organization: rtProcessInfo.procOrg ? rtProcessInfo.procOrg.orgId : '',
                organizationName: rtProcessInfo.procOrg ? rtProcessInfo.procOrg.orgName : '',
                accessLevel: rtProcessInfo.accessLevel || 'public',
                procContent: content,
                state: 0
            };
            const url = '/api/runtime/wf/v1.0/dtProcDefs';
            return this.http.post(url, JSON.stringify(postData));
        }
    }

    /**
     * 获取流程扩展属性
     * @param bizDefKey
     * @param startMode
     * @param bizCategoryId
     * @returns
     */
    getProcExtendProperty(bizDefKey: string, startMode: string, bizCategoryId: string) {
        let filter = '{';
        filter += `"bizDefKey":"${bizDefKey}",`;
        filter += `"bizCategoryId":"${bizCategoryId}",`;
        filter += `"startMode":"${startMode}"`;
        filter += '}';
        filter = encodeURIComponent(filter);
        const url = `/api/runtime/wf/v1.0/procExtendProperty?param=${filter}`;
        return this.http.get(url);
    }

    /**
     * 获取流程构件
     * @returns
     */
    getBizCmp() {
        const url = `/api/runtime/wf/v1.0/bizComponent?flowFormKey=*&owner=*&ownerType=Process`;
        return this.http.get(url);
    }

    /**
     * 获取全部流程构件
     * @param flowFormKey
     * @returns
     */
    getAllBizCmp(flowFormKey) {
        const url = `/api/runtime/wf/v1.0/bizComponent?flowFormKey=${flowFormKey}&owner=${flowFormKey}&ownerType=Process`;
        return this.http.get(url);
    }

    /**
     * 获取表单格式
     */
    getFormFormat(bizCategoryId: string) {
        if (bizCategoryId == null) {
            return of(null);
        }
        const url = `/api/runtime/wf/v1.0/formFormat/query?param=%7B%22bizCategory%22%3A%22${bizCategoryId}%22%7D`;
        return this.http.get(url);
    }

    /**
     * 获取配置
     * @returns
     */
    getGeneralConfig() {
        return this.http.get("/api/runtime/wf/v1.0/generalConfig/Is_EnableTransfer").pipe(
            switchMap((enableTransfer: any) => {
                return this.http.get("/api/runtime/wf/v1.0/generalConfig/Is_EnableNotify").pipe(
                    switchMap((enableNotify: any) => {
                        return this.http.get("/api/runtime/wf/v1.0/generalConfig/Is_EnableAddSignBehind").pipe(
                            switchMap((enableAddSignBehind: any) => {
                                return this.http.get("/api/runtime/wf/v1.0/generalConfig/Is_EnableAddSignFront").pipe(
                                    switchMap((enableAddSignFront: any) => {
                                        const res = {
                                            enableTransfer: JSON.parse(enableTransfer.currentValue),
                                            enableNotify: JSON.parse(enableNotify.currentValue),
                                            enableAddSignBehind: JSON.parse(enableAddSignBehind.currentValue),
                                            enableAddSignFront: JSON.parse(enableAddSignFront.currentValue)
                                        };
                                        return of(res);
                                    })
                                );
                            })
                        );
                    })
                );
            })
        );
    }
}
